import React from 'react';

/**
 * Reusable loading state component for Security Groups pages.
 * Displays a consistent loading spinner with page structure.
 * @param {Object} props - Component props
 * @param {string} props.title - The page title to display (default: "Security Groups")
 * @param {string} props.icon - The icon class to display (default: "fas fa-shield-alt")
 * @param {string} props.message - Loading message (default: "Loading...")
 * @returns {JSX.Element} A loading state with spinner
 */
const LoadingState = ({ 
  title = "Security Groups", 
  icon = "fas fa-shield-alt",
  message = "Loading..."
}) => {
  return (
    <div className="page-inner">
      <header className="page-title-bar">
        <h1 className="page-title">
          <i className={`${icon} text-muted mr-2`}></i>{title}
        </h1>
      </header>
      <div className="page-section">
        <div className="d-flex justify-content-center align-items-center" style={{ height: '200px' }}>
          <div className="text-center">
            <div className="spinner-border" role="status" style={{ width: '3rem', height: '3rem' }}>
              <span className="sr-only">Loading...</span>
            </div>
            <p className="mt-3 text-muted">{message}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoadingState;
